import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import * as moment from 'moment';

import { ToastrService } from 'ngx-toastr';
import { ApisService } from '../../services/apis.service';

@Component({
  selector: 'app-jockey-disqualify',
  templateUrl: './jockey-disqualify.component.html',
  styleUrls: ['./jockey-disqualify.component.scss']
})
export class JockeyDisqualifyComponent implements OnInit {

  @Input() runner;
  meta: {
    saveEnabled: boolean;
    saving: boolean;
  };
  userId: number;
  disqualifiedReasons: any[];
  disqualifiedRunner: {
    disqualifiedCode: number;
  };

  constructor(
    public activeModal: NgbActiveModal,
    private apiService: ApisService,
    private notification: ToastrService
  ) { }

  ngOnInit() {
    this.meta = {
      saveEnabled: false,
      saving: false
    }

    this.disqualifiedRunner = {
      disqualifiedCode: this.runner.disqualifiedCode
    }

    this.disqualifiedReasons = this.apiService.getDisqualifiedReasons();

    this.apiService.observableLoggedIn.subscribe(data => {
      this.userId = data.user_id;
    });
  }

  confirm() {
    this.meta.saving = true;
    let payload = {
      animalId: this.runner.animalId,
      yearOfRace: this.runner.yearOfRace,
      raceId: this.runner.raceId,
      divisionSequence: this.runner.divisionSequence,
      disqualifiedCode: 13,
      disqualifiedTimestamp: moment().format('YYYY-MM-DD HH:mm:ss'),
      // jockeyId: this.runner.jockeyId,
      updatedBy: this.userId
    };

    this.apiService.updateDisqualified(payload.yearOfRace, payload.raceId, payload.divisionSequence, payload.animalId, payload)
      .subscribe(
        res => {
          this.activeModal.close(res);
          this.notification.success(`${this.runner.animalName} has been updated as Disqualified.`, 'Disqualification');
        },
        err => {
          console.error('[ DEBUG ] Error updating non runner status', err);
          this.notification.error(`Could't update this entry. Check your connection and Try again.`, 'Disqualification');
          this.meta.saving = false;
        }
      );
  }

  // delete() {
  //   this.meta.saving = true;
  //   let payload = {
  //     animalId: this.runner.animalId,
  //     yearOfRace: this.runner.yearOfRace,
  //     raceId: this.runner.raceId,
  //     divisionSequence: this.runner.divisionSequence,
  //     disqualifiedCode: null,
  //     disqualifiedTimestamp: null,
  //     jockeyId: this.runner.jockeyId,
  //     updatedBy: this.userId
  //   };
  //
  //   this.apiService.updateDisqualified(payload.yearOfRace, payload.raceId, payload.divisionSequence, payload.animalId, payload)
  //     .subscribe(
  //       res => {
  //         this.activeModal.close(res);
  //         this.notification.success(`${this.runner.animalName} has been reset and is not longer Disqualified.`, 'Disqualification');
  //       },
  //       err => {
  //         console.error('[ DEBUG ] Error updating non runner status', err);
  //         this.notification.error(`Could't update this entry. Check your connection and Try again.`, 'Disqualification');
  //         this.meta.saving = false;
  //       }
  //     );
  // }

  cancel(action) {
    this.activeModal.dismiss(action);
  }

}
